export default "__VITE_ASSET__DjgzBsuO__"